module.exports = __webpack_public_path__ + "media/images/top-page_illustration-step3-989f6a411f9a870cda0a141f3376c72c.svg";